import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, } from "@mui/styles"

const useStyles = makeStyles((theme) => ({
  parallax: {
    minHeight: (props) => props.height,
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const Parallax = (props) => {
  const { height, imageUrl, children } = props;
  const classes = useStyles(props);

  return (
    <div
      className={classes.parallax}
      style={{
        height,
        backgroundImage: `url(${imageUrl})`,
      }}
    >
      {children}
    </div>
  );
};

Parallax.propTypes = {
  height: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  children: PropTypes.node,
};

Parallax.defaultProps = {
  height: '400px',
  children: null,
};

export default Parallax;